export default __webpack_public_path__ + "static/rose-44b5d301001c31f2d36c4fb4df849d7c.png";